import { render, staticRenderFns } from "./HeaderCollapseCards.vue?vue&type=template&id=7368a6b2&"
var script = {}
import style0 from "./HeaderCollapseCards.vue?vue&type=style&index=0&id=7368a6b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports